// Tracks the last time a real backend request went out via axiosPrivate.
// Used by useIdleLogout — deliberately not driven by raw DOM events or the
// silent token-refresh loop, only genuine authenticated API calls.
let lastActivityAt = Date.now();

export const markActivity = () => { lastActivityAt = Date.now(); };

export const getLastActivity = () => lastActivityAt;
